(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeNewsletterPopup = () => {
      const popup = document.querySelector('[data-newsletter-popup]');
      if (!popup || popup.dataset.initialized === 'true') return;

      popup.dataset.initialized = 'true';

      const storageKey = 'startechoffice-newsletter-popup-v1';
      const delay = Number(popup.dataset.popupDelay || 5000);
      const dismissDays = Number(popup.dataset.popupDismissDays || 30);
      const success = popup.querySelector('[data-newsletter-popup-success]');
      const errors = popup.querySelector('.newsletter-popup__errors');
      const closeButton = popup.querySelector('[data-newsletter-popup-close]');
      const form = popup.querySelector('#NewsletterPopupForm');
      const submitButton = form?.querySelector('.newsletter-popup__submit');

      const readDismissedAt = () => {
        try {
          return Number(window.localStorage.getItem(storageKey) || 0);
        } catch {
          return 0;
        }
      };

      const rememberDismissal = () => {
        try {
          window.localStorage.setItem(storageKey, String(Date.now()));
        } catch {
          return;
        }
      };

      const openPopup = () => {
        if (popup.open) return;
        if (typeof popup.showModal === 'function') {
          popup.showModal();
        } else {
          popup.setAttribute('open', '');
        }
      };

      const closePopup = () => {
        rememberDismissal();
        if (typeof popup.close === 'function') {
          popup.close();
        } else {
          popup.removeAttribute('open');
        }
      };

      closeButton?.addEventListener('click', closePopup);

      popup.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup();
      });

      popup.addEventListener('click', (event) => {
        if (event.target !== popup) return;
        const rect = popup.getBoundingClientRect();
        const outside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;
        if (outside) closePopup();
      });

      form?.addEventListener('submit', () => {
        if (!form.checkValidity() || form.dataset.submitting === 'true') return;

        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.textContent = 'ENVIANDO...';
        }
      });

      if (success || errors) {
        if (success) rememberDismissal();
        openPopup();
        success?.focus();
        return;
      }

      const dismissedAt = readDismissedAt();
      const dismissalWindow = dismissDays * 24 * 60 * 60 * 1000;
      if (dismissedAt && Date.now() - dismissedAt < dismissalWindow) return;

      window.setTimeout(openPopup, Math.max(0, delay));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeNewsletterPopup, { once: true });
    } else {
      initializeNewsletterPopup();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
